module.exports = __webpack_public_path__ + "img/template39_mobile.4038ffea.png";